// ABOUTME: Simple tooltip component for displaying hover information.
// ABOUTME: Shows content on hover with basic positioning.

import { ReactNode, useState } from 'react';

interface TooltipProps {
  content: string;
  children: ReactNode;
  className?: string;
}

export function Tooltip({ content, children, className = '' }: TooltipProps) {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div
      className="relative inline-block"
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {children}
      {isVisible && content && (
        <div
          className={`absolute z-50 px-3 py-2 text-xs text-surface-900 dark:text-surface-0 bg-surface-0 dark:bg-surface-800 border border-surface-200 dark:border-surface-700 rounded-sm shadow-lg
                      bottom-full left-1/2 -translate-x-1/2 mb-2 whitespace-normal ${className}`}
          style={{ minWidth: '200px', maxWidth: '300px' }}
        >
          {content}
          <div className="absolute w-2 h-2 bg-surface-0 dark:bg-surface-800 border-l border-b border-surface-200 dark:border-surface-700 transform rotate-45 -bottom-1 left-1/2 -translate-x-1/2" />
        </div>
      )}
    </div>
  );
}
